import { ContactFacetType } from "@/Common/Models/Individuals/Enums/ContactFacetType";
import { Person } from "@/Common/Models/Person/Person";

import styles from "./RelationView.module.scss";

import img_patient_icon from "@/Common/_images/patient-icon.png";
import img_relative_icon from "@/Common/_images/relative-icon.png";

interface IRelativeIconProps {
    person: Person;
}

function RelativeIcon(props: IRelativeIconProps): JSX.Element {
    const imageIcon = props.person.ContactFacetType === ContactFacetType.Patient ? img_patient_icon : img_relative_icon;

    return (
        <div className={styles.relationIcon}>
            <img
                title={props.person.NameWithIdentifier}
                src={imageIcon}
                className={styles.relationIconImage}
                alt={props.person.NameWithIdentifier}
            />
        </div>
    );
}

export { RelativeIcon };
